import { render, staticRenderFns } from "./AndroidPage.vue?vue&type=template&id=6a4d8dde&scoped=true&"
import script from "./AndroidPage.vue?vue&type=script&lang=js&"
export * from "./AndroidPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4d8dde",
  null
  
)

export default component.exports